import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

export function KPICard({
  label,
  value,
  hint,
  icon: Icon,
  tone = "default",
  progress,
  testid,
  delay = 0,
}) {
  const toneClass = {
    default: "text-foreground",
    success: "text-[hsl(var(--success))]",
    warning: "text-[hsl(var(--warning))]",
    danger: "text-[hsl(var(--danger))]",
    primary: "text-primary",
  }[tone];

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay }}
      data-testid={testid}
      className="relative flex flex-col justify-between rounded-xl border border-border bg-card p-5 shadow-sm transition-all hover:border-primary/30 hover:shadow-md"
    >
      <div className="flex items-start justify-between gap-3">
        <span className="label-caps">{label}</span>
        {Icon && (
          <div className="rounded-md bg-muted p-2 text-muted-foreground">
            <Icon className="h-4 w-4" strokeWidth={1.75} />
          </div>
        )}
      </div>
      <div className={cn("metric-value mt-6 text-3xl sm:text-4xl", toneClass)}>{value}</div>
      {hint && <div className="mt-2 text-xs text-muted-foreground tabular-nums">{hint}</div>}
      {typeof progress === "number" && (
        <div className="mt-4 h-1.5 w-full overflow-hidden rounded-full bg-muted">
          <div
            className="h-full rounded-full bg-primary transition-all duration-700"
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
        </div>
      )}
    </motion.div>
  );
}
